import API from "../utils/baseUrl";
let token = "Bearer " + localStorage.getItem("jwt");

/************************************* GET REQUEST ******************************************/

export const getQueryRequest = (endPoint, params) => {
  let url = `${API}/${endPoint}?${params}`;
  return fetch(url, {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: `${token}`,
    },
  })
    .then((response) => {
      if (response.status === 200 || response.status === 422) {
        return response.json();
      } else {
        return new Promise((resolve, reject) => {
          resolve({ error: response.statusText });
        });
      }
    })
    .catch((err) => console.log(err));
};
